import { UserRoleType } from '../../models/user.model';
import { MultichannelNames } from '../company/company.model';

export interface UserDetails {
  id: string;
  loginId?: string;
  address?: UserAdress;
  gender?: Gender;
  languageCode?: string;
  userState?: UserState;
  name: UserName;
  contacts?: UserContact;
  company?: UserCompany;
  applicationRoles?: string[];
  businessRoles?: string[];
  properties?: UserProperties[];
  validity?: UserValidity;
}

export interface LoggedInUserDetails extends UserDetails {
  iotRole: UserRoleType;
  contact: string;
}

export interface UserName {
  firstName?: string;
  familyName?: string;
}

export interface UserAdress {
  postalCode?: string;
  city?: string;
  street?: string;
  houseNumber?: string;
  countryCode?: string;
  locality?: string;
}

export interface UserContact {
  telephone?: string;
  telefax?: string;
  mobile?: string;
  email?: string;
}

export interface UserCompany {
  name?: string;
  vkorg?: string;
  countryCode?: string;
  id: string;
  multichannel: MultichannelNames;
}

export interface UserProperties {
  name?: string;
  value?: string;
}

export interface UserValidity {
  from?: string;
  to?: string;
}

export enum Gender {
  Male = 'MALE',
  Female = 'FEMALE',
  Other = 'OTHER',
}

export enum UserState {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
}

export enum UserPropertyEnum {
  IdentityType = 'IdentityType',
  EmailVerified = 'EmailVerified',
}

export enum UserPropertyValueEnum {
  ViInt = 'ViInt',
  J = 'J',
}

export interface ChangeUserDetailsRequest {
  address?: UserAdress;
  contacts?: {
    email?: string;
    mobile?: string;
    telefax?: string;
    telephone?: string;
  };
  name?: {
    familyName?: string;
    firstName?: string;
  };
  validity?: {
    from?: string;
    to?: string;
  };
  birthDate?: string;
  languageCode?: string;
  gender?: Gender;
  userState?: UserState;
  loginId?: string;
}

export namespace UserRegistrationModel {
  export const baseUrl = 'users/v1/users';
  export const meEndpointPath = `${baseUrl}/me`;
}
